'use strict';

const CLASS = 'placemark';
const ACTIVE_CLASS = 'in';

class YaMap {
    _map;
    _objectManager;
    _placemarks;
    _params;
    _suggestView;
    _addressSearchPlacemark;

    constructor(e, placemarks, params) {
        window.globalMapObject = this;
        this.e = e;
        this._placemarks = placemarks;
        this._params = params;
    }

    render() {
        ymaps.ready(() => {
            console.log('tst');
            // Фильтруем дубликаты
            const uniquePlacemarks = this._filterUniquePlacemarks(this._placemarks);

            this._objectManager = this._setObjectManager(this._params.clickCallback, uniquePlacemarks);
           // this._objectManager = this._setObjectManager(this._params.clickCallback);
            this._setIconLayout(this._placemarks);
            window.mapObj = this._map = this._setMap();

            this._suggestView = new ymaps.SuggestView("address_search", {
                boundedBy: this._map.getBounds(),
            });
            this._suggestView.events.add("select", (e) => {
                window.eSelected = e;
                window.itemSelected = e.get("item");
                ymaps.geocode(itemSelected.value, {
                    results: 1
                }).then(function (res) {

                    var firstGeoObject = res.geoObjects.get(0);
                    window.test = firstGeoObject;
                    var coords = firstGeoObject.geometry.getCoordinates();
                    $.ajax({
                        url: '/ajax/find-closest-address',
                        method: 'POST',
                        data: {lat: coords[0], lon: coords[1]},
                        success: function (data) {
                            if (data.filterIds) {
                                globalMapObject.filter(data);
                                firstGeoObject.options.set('preset', 'islands#darkGreenDotIconWithCaption');
                                firstGeoObject.properties.set('iconCaption', firstGeoObject.getAddressLine());
                                if (globalMapObject._addressSearchPlacemark) {
                                    globalMapObject._addressSearchPlacemark.geometry.setCoordinates(coords);
                                } else {
                                    globalMapObject._map.geoObjects.add(firstGeoObject)
                                    globalMapObject._addressSearchPlacemark = firstGeoObject;
                                }
                                globalMapObject._map.setBounds(globalMapObject._map.geoObjects.getBounds());


                            }
                        }
                    })

                });
            });

        });
    }

    _filterUniquePlacemarks(placemarks) {
        const seenCoordinates = new Set();
        return placemarks.filter(placemark => {
            const coordinates = `${placemark.geometry.coordinates[0]},${placemark.geometry.coordinates[1]}`;
            if (seenCoordinates.has(coordinates)) {
                return false;
            } else {
                seenCoordinates.add(coordinates);
                return true;
            }
        });
    }

    filter(filters) {
        this._objectManager.setFilter(this._resetFilter())

        if (!this._objectManager) {
            console.error('Object Manager is not initialized');
            return;
        }
        this._objectManager.setFilter(this._resetFilter())
        this._objectManager.setFilter(this._getFilterStatus(filters));

        let result_filter = this._objectManager.objects.getAll().filter((x) => {
            return !this._objectManager.getObjectState(x.id).isFilteredOut;
        })

        return result_filter;
    }
    _resetFilter() {
        return function (placemark) {
            return true;
        }
    }
    _getFilterStatus(arrayFilters) {
        return function (placemark) {
            let status = false;
            if (arrayFilters.hasOwnProperty('filterIds')) {
                return arrayFilters.filterIds.includes(placemark.address);
            }
            for (let index in arrayFilters) {
                let filters = arrayFilters[index];
                let match_count = 0;
                let filter_count = Object.keys(filters).length;

                for (let i in filters) {
                    if (filters[i] === +placemark.services[i]) {
                        match_count++;
                    }
                }

                if (filter_count === match_count) {
                    return true
                }
            }
            return status;
        }
    }

    setActivePlacemark(id, centered = false) {
        this._objectManager.objects.each((object) => {
            let elem = $('#' + object.id);

            if (object.id === id) {
                elem.addClass('in');
                let coordinates = object.geometry.coordinates;
                $(this._objectManager.objects.getById(object.id)).addClass(ACTIVE_CLASS);
                //this._objectManager.objects.getById(object.id).class = ACTIVE_CLASS; // РР·РјРµРЅСЏРµРј РѕР±СЉРµРєС‚ РІ РјРµРЅРµРґР¶РµСЂРµ РѕР±СЉРµРєС‚РѕРІ
                if (centered) {
                    this._setMapCenter(coordinates[0], coordinates[1]);
                }
            } else {
                elem.removeClass('in');
                $(this._objectManager.objects.getById(object.id)).removeClass(ACTIVE_CLASS);
                //this._objectManager.objects.getById(object.id).class = CLASS; // РР·РјРµРЅСЏРµРј РѕР±СЉРµРєС‚ РІ РјРµРЅРµРґР¶РµСЂРµ РѕР±СЉРµРєС‚РѕРІ
            }
        })
    }

    setBounds(map) {
        map.setBounds(this._objectManager.getBounds(), {
            checkZoomRange: true,
            duration: 500,
            useMapMargin: true
        });
    }

    getMap() {
        return this._map;
    }

    _setIconLayout() {
        let iconLayout = ymaps.templateLayoutFactory.createClass('<div id="{{ id }}" class="{{ class }}"></div>');

        this._objectManager.objects.options.set({
            iconLayout: iconLayout,
            iconShape: {
                type: 'Circle',
                coordinates: [0, 0],
                radius: 42
            }
        });
    }

    _setObjectManager(callback, placemarks) {
        let objectManager = new ymaps.ObjectManager({clusterize: true});
        objectManager.add(placemarks);

        objectManager.clusters.options.set({preset: 'islands#redClusterIcons'});

        if (callback) {
            objectManager.objects.events.add(['click'], function (e) {
                callback(e);
            });
        }

        return objectManager;
    }

    _setMap() {
        let map = new ymaps.Map(this.e, {
                center: [this._params.center.lat, this._params.center.lon],
                zoom: this._params.zoom,
                avoidFractionalZoom: false,
                controls: []
            }, {
                autoFitToViewport: 'always',
                minZoom: 8,
                maxZoom: 16
            }
        );

        //map.behaviors.disable('scrollZoom');
        //map.behaviors.disable('drag');

        map.controls.add('zoomControl', {position: {right: '20px', top: '100px'}});

        map.geoObjects.add(this._objectManager);

        this.setBounds(map);

        $('[class *="-ground-pane"]').addClass('grayscale'); //Р”РµР»Р°РµРј РєР°СЂС‚Сѓ С‡РµСЂРЅРѕ-Р±РµР»РѕР№

        return map;
    }

    _setMapCenter(lat, lon) {
        this._map.setCenter([lat, lon], 15, {
            checkZoomRange: true,
            duration: 500,
            useMapMargin: true
        })
    }
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = YaMap;
}